
import React from "react";
import ContactForm from "./contact/ContactForm";
import ContactLocations from "./contact/ContactLocations";
import ContactQuickInfo from "./contact/ContactQuickInfo";

const ContactSection = () => (
  <section id="contact" className="section-padding bg-gradient-to-b from-white to-gray-50">
    <div className="container mx-auto container-padding">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-bold gradient-text mb-4">
          Get in Touch
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Have questions about our custom technology solutions? Ready to discuss your project? 
          Our team is here to help you build the perfect hardware for your needs.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Contact Form */}
        <ContactForm />
        {/* Info, Locations, Quick Contact */}
        <div>
          <ContactQuickInfo />
          <ContactLocations />
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection;
